import React from "react";
import "./mmenu.css";
import { Link } from "react-router-dom";

function MobileMenu({ show, className }) {

  function toggleMenu() {
    document.querySelector(".mobile-menu").classList.toggle("show");
  }

  return (
    <div className="mobile-menu">
      <div className="back-icon" onClick={toggleMenu}></div>
      <div className="header-menu"></div>
      <div className="header-logo mobile-logo"></div>
      <div className="menu-link" onClick={toggleMenu}>
        <Link to="/services">سرویس‌های مپ</Link>
        <Link to="/services">راهکارهای مپ</Link>
        <a
          href="https://support.map.ir"
          target="_blank"
          rel="noopener noreferrer"
        >
          مستندات
        </a>
        <a
          href="https://corp.map.ir/contact-us/"
          target="_blank"
          rel="noopener noreferrer"
        >
          تماس با ما
        </a>
        <a
          href="https://corp.map.ir/registration/"
          target="_blank"
          rel="noopener noreferrer"
        >
          ورود / ثبت‌نام
        </a>
        {/* <a href="#" className="">
                    جستجو
                </a> */}
      </div>
    </div>
  );
}

export default MobileMenu;
